

























































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Train extends Vue {
  @Prop({ required: true })
  tr!: string;
  @Prop({ required: true })
  ik!: string;
  @Prop({ required: true })
  sy!: string;
  @Prop({ required: true })
  ki!: boolean;
  @Prop({ required: true })
  unyo!: string;
  @Prop({ required: true })
  vehicle!: string;
  @Prop({ required: true })
  bgStyle!: string;
  @Prop({ required: true })
  line!: "KO" | "S";
}
